import { Need, ValueRanges } from 'rlv-common';
import { ViewName } from '../../../helpers/ViewName';
import { NeedPageData } from '../../../pages/needs/Needs.types';
import NeedsPageContainer from '../../../pages/needs/NeedsPageContainer';
import {
  getAngebot,
  updateConstantNeedBlockData,
  updateDecreasingNeedBlockData,
  updateNeedPageData,
} from '../../../services/api';
import { PagePercentage } from '../../../types/PagePercentage';
import { createNeedPageSchema } from '../../../validation/NeedPage';
import { StateDefinition } from '../../StateMachine';
import { NavigationAction, StateName } from '../../StateMachineTypes';

export const needPageState: StateDefinition<NeedPageData> = {
  name: StateName.NEED_PAGE,
  percentage: PagePercentage.NEED_PAGE,
  trackingViewName: ViewName.BEDARFSANALYSE,
  createValidationSchema: (valueRanges: ValueRanges) => createNeedPageSchema(valueRanges),
  validInboundStates: [
    StateName.LIVING_CONDITIONS_PAGE,
    StateName.LEGAL_QUESTIONS_SUMMARY_PAGE,
    StateName.LIVING_CONDITIONS_BIRTHDATE,
    StateName.CONSTANT_SUM_INSURED,
    StateName.DECREASING_SUM_INSURED,
  ],
  transitions: [
    {
      test: (action, data) => {
        const backAction =
          action === NavigationAction.BACK || action === NavigationAction.BROWSER_BACK;
        return backAction;
      },
      newState: StateName.LIVING_CONDITIONS_BIRTHDATE,
    },
    {
      test: (action, data) =>
        action === NavigationAction.NEXT && data.userInput.need === Need.KONSTANT,
      newState: StateName.CONSTANT_SUM_INSURED,
    },
    {
      test: (action, data) =>
        action === NavigationAction.NEXT && data.userInput.need === Need.DECREASING,
      newState: StateName.DECREASING_SUM_INSURED,
    },
  ],
  onEnter: async (transitionDetails, inputData) => {
    const response = await getAngebot(inputData.businessId);

    return {
      userInput: {
        ...response.needSelectionModel,
        need:
          response.needSelectionModel?.need ??
          inputData.userInput?.need ??
          Need.KONSTANT,
      },
      valueRanges: response.valueRanges,
    };
  },

  onExit: async (transitionDetails, inputData) => {
    await updateNeedPageData(inputData.businessId, inputData.userInput);
    if (inputData.userInput.need === Need.KONSTANT) {
      await updateConstantNeedBlockData(inputData.businessId, inputData.userInput);
    } else if (inputData.userInput.need === Need.DECREASING) {
      await updateDecreasingNeedBlockData(inputData.businessId, inputData.userInput);
    } else {
      throw new Error(`Error in NeedPage, illegal value for need: ${inputData.userInput.need}`);
    }

    return {};
  },

  render: (inputData, handleAction, updateApp, _unused, updateDTMTracking) => {
    const userInput: NeedPageData = inputData.userInput;

    return (
      <NeedsPageContainer
        businessId={inputData.businessId}
        inputData={inputData}
        updateApp={updateApp}
        storeState={{
          need: userInput.need,
          update: values => updateApp(values),
        }}
        valueRanges={inputData.valueRanges}
        handleAction={handleAction}
        updateDTMTracking={updateDTMTracking}
      />
    );
  },
};
